import { Box, Container } from '@material-ui/core'
import { useState } from 'react'

import { Stepper } from '@/components/stepper'

import { ConcludedStep } from './steps/concluded-step'
import { ConfirmStep } from './steps/confirm-step'
import { useStyles } from './styles'

const steps = [ConfirmStep, ConcludedStep]

const stepsLabel = ['Confirmar atividade', 'Finalizar confirmação']

export function SavePulverizationActivity() {
  const classes = useStyles()

  const [currentStep, setCurrentStep] = useState(0)

  const StepComponent = steps[currentStep]

  return (
    <Container className={classes.container}>
      <Box marginTop={'4rem'}>
        <Stepper activeStep={currentStep} steps={stepsLabel} />
      </Box>

      <StepComponent onChangeCurrentStep={setCurrentStep} />
    </Container>
  )
}
